import { useMemo } from 'react';
import { CSSTransition } from 'react-transition-group';
import mic from '~/assets/icons/mic.svg';
import { rage, useObservable } from '~/rage';
import {
	StyledBackCircle,
	StyledContainer,
	StyledIconContainer,
} from './MicroStatus.styled';

const MicroStatus = () => {
	const notification = useObservable(
		rage.notifications.getDisplayedNotification(),
	);
	const notifications = useObservable(
		rage.notifications.getDisplayedNotifications(),
	);
	const playerIsTalking = useObservable(rage.player.getPlayerIsTalking());

	const notificationCount = useMemo(() => {
		if (notification?.duration !== undefined) {
			return 1;
		}

		return Math.min(3, notifications.length);
	}, [notification, notifications]);

	const bottom = useMemo(() => {
		const notificationLiftByCount = [0, 60, 110, 160];
		return 40 + notificationLiftByCount[notificationCount];
	}, [notificationCount]);

	return (
		<CSSTransition
			in={playerIsTalking}
			timeout={300}
			classNames={'micro'}
			unmountOnExit
			appear
		>
			<StyledContainer style={{ bottom: bottom }}>
				<StyledBackCircle />
				<StyledIconContainer>
					<img src={mic} />
				</StyledIconContainer>
			</StyledContainer>
		</CSSTransition>
	);
};

export { MicroStatus };
